import artifact from '$houdini/artifacts/RemoveChartFromReportMutation'
import { MutationStore } from '../runtime/stores/mutation'

export class RemoveChartFromReportMutationStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
